import { BiPhoneCall, BiLink, BiLinkExternal, BiLogoWhatsapp, BiEnvelope, BiCart } from "react-icons/bi";
import { Link } from 'react-router-dom'

export default function Ctaicon({ iconName, destination, customtext = '', reflistingid = '' }) {

    var localdestination = destination;
    var localcustomtext = customtext;
    if (reflistingid !== '' && destination === '/contacto') {
        localdestination = `${localdestination}/${reflistingid}`;
        localcustomtext = 'Contactar';
    }
    const getIconComponent = (iconName) => {
        switch (iconName) {
            case 'phone-call':
                return <>
                    <Link to={`tel:${destination}`} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center">
                        <BiPhoneCall fontSize={'2em'} /><span> {customtext ? customtext : 'Llamar'}</span>
                    </Link>
                </>;
            case 'link':
                return <>
                    <Link to={localdestination} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center">
                        <BiLink fontSize={'2em'} /><span> {localcustomtext !== '' ? localcustomtext : 'Ver más'}</span>
                    </Link>
                </>;
            case 'link-external':
                return <>
                    <Link to={destination} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center" target="_blank">
                        <BiLinkExternal fontSize={'2em'} /><span> {customtext ? customtext : 'Ver más'}</span>
                    </Link>
                </>;
            case 'cart':
                return <>
                    <Link to={destination} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center">
                        <BiCart fontSize={'2em'} /><span> {customtext ? customtext : 'Comprar'}</span>
                    </Link>
                </>;
            case 'payevent':
                return <>
                    <Link to={destination} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center">
                        <BiCart fontSize={'2em'} /><span> Realizar el pago</span>
                    </Link>
                </>;
            case 'whatsapp':
                return <>
                    <Link to={`https://wa.me/${destination}`} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center">
                        <BiLogoWhatsapp fontSize={'2em'} /><span> {customtext ? customtext : 'Whatsapp'}</span>
                    </Link>
                </>;
            case 'envelope':
                return <>
                    <Link to={`mailto:${destination}`} className="btn btn-success w-100 btn-sm mb-2 mx-auto text-center">
                        <BiEnvelope fontSize={'2em'} /><span> {customtext ? customtext : 'Enviar correo'}</span>
                    </Link>
                </>;
            default:
                return null;
        }
    };

    return (
        <>
            {getIconComponent(iconName)}
        </>
    );
}